import $ from 'jquery';

import StaticArticleList from './StaticArticleList';

export default class StaticBlog {
  constructor(section) {
    this.$el = $(section.el);
    this.listViews = [];

    this.render();
  }

  render() {
    const $articleListItem = $('[data-blog-list-item]', this.$el);

    if ($articleListItem.length === 0) { return; }

    $articleListItem.map((i, listItem) => this.listViews.push(new StaticArticleList({ el: listItem })));
  }

  onSectionLoad() {
    this.render();
  }

  onSectionUnload() {
    this.listViews.map(listView => listView.remove());
  }
}
